import Text, { FontTypes } from '@ab-core/text';
import type { FC } from 'react';
import React from 'react';
import type { CounterType } from '../../..';
import { getFormattedCounterNumber } from '../../../reducer';
import { NewValue } from './styled';

type TooltipContentProps = Pick<CounterType, 'quantityUnit'> & {
    nextPossibleValue: CounterType['quantity'];
};

export const TooltipContent: FC<TooltipContentProps> = (props) => {
    const { nextPossibleValue, quantityUnit } = props;

    if (!nextPossibleValue) {
        return <></>;
    }

    return (
        <Text type={FontTypes.Subtitle} color="gray50">
            Die gewählte Bestellmenge ist für diesen Artikel nicht möglich und wird auf folgenden Wert geändert:&nbsp;
            <NewValue>{getFormattedCounterNumber({ quantity: nextPossibleValue, quantityUnit })}</NewValue>
        </Text>
    );
};
